import { Tooltip, Typography } from "@mui/material";
import { StyledFeature } from "../../../../styled/Labels";

const FeatureLabel = ({ labelText, icon, onClick, tooltipText }) => {

  return (
    <StyledFeature.LabelContainer>
      <Typography>{labelText}</Typography>

      <Tooltip title={tooltipText} arrow>
        <span>
          {icon &&
            <StyledFeature.Icon fontSize="large" icon={icon} onClick={onClick} />
          }
        </span>
      </Tooltip>

    </StyledFeature.LabelContainer>
  );
};

export default FeatureLabel;
